import React from 'react';
import { marked } from 'marked';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

function BlogPostPage({ post, navigateTo }) {
  if (!post) {
    return (
      <div className="py-16 md:py-24 text-center">
        <p className="text-xl text-gray-600">Post not found. Please return to the blog.</p>
        <button onClick={() => navigateTo('blog')} className="mt-4 btn btn-primary">Back to Blog</button>
      </div>
    );
  }

  let contentNode = <p>No content available for this post.</p>;
  if (post.fields.content) {
    if (typeof post.fields.content === 'string') {
      contentNode = <div dangerouslySetInnerHTML={{ __html: marked.parse(post.fields.content) }} />;
    } else if (typeof post.fields.content === 'object') {
      contentNode = documentToReactComponents(post.fields.content);
    }
  }

  return (
    <div className="py-16 md:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => navigateTo('blog')}
          className="mb-8 text-indigo-600 hover:text-indigo-800 font-medium flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2">
            <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" />
          </svg>
          Back to Blog
        </button>
        {post.fields.featuredImage && (
          <img
            src={post.fields.featuredImage.fields.file.url}
            alt={post.fields.title}
            className="w-full h-auto max-h-96 object-cover rounded-lg mb-8 shadow-lg"
            onError={e => { e.target.onerror = null; e.target.src = 'https://placehold.co/800x400/cccccc/ffffff?text=Image+Not+Found'; }}
          />
        )}
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{post.fields.title}</h1>
        <p className="text-gray-500 text-sm mb-6">
          Published on {new Date(post.sys.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
        <div className="prose prose-lg max-w-none text-gray-700">
          {contentNode}
        </div>
      </div>
    </div>
  );
}

export default BlogPostPage; 